import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: ADIAdonisYesProductDescriptionStyles;
}

type Props = OwnProps;

export interface ADIAdonisYesProductDescriptionStyles {
    productDetailDescription?: TypographyProps;
}

export const adiAdonisYesProductDescriptionStyles: ADIAdonisYesProductDescriptionStyles = {};

const ADIAdonisYesProductDescription: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(adiAdonisYesProductDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");

    return <Typography {...styles.productDetailDescription}>{description}</Typography>
};

export default ADIAdonisYesProductDescription;
